import React from "react";
import Head from 'next/head'
import Layout from '../../../components/layout';
  
export async function getServerSideProps({ query }) {
  // 
  let faceShapeTemp = ["Oval"];
  if (query.faceShape) {
    faceShapeTemp = Array.isArray(query.faceShape) ? query.faceShape : [query.faceShape];
  }
  // const [faceShape, setFaceShape] = useState(faceShapeTemp);
  
  return {
    props: {
      // page: query.page || null,
      faceShape: faceShapeTemp,      
      // setFaceShape: setFaceShape,
    },
  };
}

export default function HomePage({ faceShape }) {
return (
  <>
    <Head>
      <title>Face Contour for Beginners | Personalized Makeup Guidance with AI</title>
      <link
          rel="canonical"
          href="https://stylesense.io/makeup-recommendations/face-contour"
          key="canonical"
        />   
      <meta
        name="description"
        content="Our AI makeup filters provide follow-along contour guides tailored to your face shape. Our smart, personalized service recommends the beauty look that'll best accentuate your facial features. It's as easy as a TikTok or Snapchat filter — we use AR to overlay makeup contour guides on your face in real-time, and an advanced algorithm to identify your face shape."
        key="desc"
      />
      <meta name="keywords" content="face contour, makeup guides, personalized makeup, AI makeup, AR makeup, face shape analysis, beauty tech" />
      <meta property="og:title" content="Face Contour for Beginners | Personalized Makeup Guidance with AI" />
      <meta property="og:description" content="Discover how our AI-driven makeup filters can enhance your facial features with personalized contour guides. Perfect for beginners!" />
      <meta property="og:url" content="https://stylesense.io/makeup-recommendations/face-contour" />
      <meta property="og:type" content="website" />
      <meta name="twitter:title" content="Face Contour for Beginners | Personalized Makeup Guidance with AI" />
      <meta name="twitter:description" content="Learn to contour like a pro with our AI-powered makeup guides. Tailored to your unique face shape, our AR technology makes it easy!" />
      <link rel="icon" href="/favicon.ico" />      
    </Head>    
    <Layout page={"makeup_recommendations"} faceShape={ faceShape } selectedOption={"makeup_recommendations/face_contour"}/>
    {/* <main className={styles.main}>
    <Navbar />
    <DropdownWithDescription selectedOption={"makeup_recommendations"}/>
    <FaceMeshComponent page={"makeup_recommendations"} faceShape={ faceShape }/>     
    <Footer />
    </main> */}
  </>
  )
}

// export default HomePage;